import { render, staticRenderFns } from "./Artikel.vue?vue&type=template&id=1a3bf8ba&scoped=true"
import script from "./Artikel.vue?vue&type=script&lang=ts"
export * from "./Artikel.vue?vue&type=script&lang=ts"
import style0 from "./Artikel.vue?vue&type=style&index=0&id=1a3bf8ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3bf8ba",
  null
  
)

export default component.exports